import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from '@data/project/project.service';
import { AdminService } from '@modules/admin/services/admin.service';
import { CommonDataService } from '@shared/services/common-data.service';
import { NotificationService } from '@shared/services/notification.service';
import { takeWhile } from 'rxjs/operators';
import { HomeService } from '../services/home.service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.less'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  codeAuth: any;
  storedUserData: any;
  searchTitle: any;
  searchTitleResults: projectSearch[];
  searchButton: any = {
    icon: 'search',
    stylingMode: 'text',
    type: 'normal',
    disabled: true,
  };
  recent_projects: any;
  noSearchResultText: string = '';
  isProjectListDropDownOpened = false;
  message: any;
  userID: any;
  uuid: any;

  recentlyViewedSearch: any[]=[];

  //primeng

    selectedItem: any;

    productResult: any[];

  //end

  constructor(
    private router: Router,
    private commonServices: CommonDataService,
    private homeService: HomeService,
    private _proj: ProjectService,
    private http: HttpClient,
    private _notify: NotificationService,
    private adminService: AdminService
  ){
    this.getRecentProjects();
  }

  ngOnInit(): void {}

  onSelectionChanged(event: any) {
    let selectedProjectId = event.value.projectId ?? null;
    this.isProjectListDropDownOpened = false;
    if(selectedProjectId)
      this.router.navigateByUrl(selectedProjectId.toString());
  }

  onRecentSelection(id: any){
    this.router.navigateByUrl(id.toString());
  }

  getSearchTitles(event: any) {
    let searchQuery = event.query;
    this.noSearchResultText = 'Enter minimum 2 character';
    if (searchQuery.length > 1) {
      this.noSearchResultText = 'Searching...';
      this.isProjectListDropDownOpened = true;
      this._proj.searchProject(searchQuery).subscribe(
        (res) => {
          if (res.status == 'SUCCESS' && res.serviceResult) {
            this.productResult = res.serviceResult;
          } else {
            this.productResult = [];
            this.noSearchResultText = 'No project found';
          }
        },
        (e) => {
          this.productResult = [];
          this.noSearchResultText = 'No project found';
        }
      );
    } else {
      this.productResult = [];
      this.noSearchResultText = 'Enter minimum 2 character';
      this.isProjectListDropDownOpened = false;
      event.component.focus();
    }
  }

  getRecentProjects(){
    let mpgUserId = this.commonServices.userInfo.value.mpgpsrUserId;
    this._proj.getRecentlyViewedTitlesByUser(mpgUserId).subscribe(
      r=>{
        if(r.status=="SUCCESS" && r.serviceResult){
          this.recentlyViewedSearch = r.serviceResult;
        }
      },
      e=>{
        console.log(e)
      }
    );
  }

  // getRecentProjects() {
  //   this.homeService
  //     .getRecentProjectsList()
  //     .subscribe((result) => (this.recent_projects = result ?? []));
  // }

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('home');
  }

}

interface projectSearch {
  projectId: number;
  title: string;
}


